const { resolveInterventionStateFields } = require('./interventionState');

const metadataFor = intervention => {
  const value = intervention?.metadata ?? intervention?.metadata_json;
  if (value && typeof value === 'object') return value;
  try { return JSON.parse(value || '{}') || {}; } catch (_) { return {}; }
};

const revisionSourceId = intervention => {
  const metadata = metadataFor(intervention);
  return metadata.revision?.sourceInterventionId || metadata.revision?.source_intervention_id ||
    intervention?.proposalSourceInterventionId || intervention?.proposal_source_intervention_id || null;
};

// Case/region access is enforced separately. Review coverage does not confer
// proposal authorship, and technical support is not a business submitter.
const canStartInterventionRevision = role =>
  ['isetcoordinator', 'regionalmanager'].includes(String(role || '').toLowerCase().replace(/[ _-]/g, ''));

const isEligibleInterventionRevisionSource = intervention => {
  const metadata = metadataFor(intervention);
  return Boolean(intervention &&
    !['cancelled', 'archived', 'withdrawn'].includes(String(intervention.status || '').trim().toLowerCase()) &&
    !revisionSourceId(intervention) &&
    !intervention.isAppliedRevisionEvidence &&
    !intervention.is_applied_revision_evidence &&
    intervention.operational !== false &&
    metadata.revisionApplication?.status !== 'applied' &&
    metadata.revision_application?.status !== 'applied' &&
    ['approved', 'in_progress', 'suspended', 'completed'].includes(resolveInterventionStateFields(intervention).effectiveStatus));
};

module.exports = { metadataFor, revisionSourceId, canStartInterventionRevision, isEligibleInterventionRevisionSource };
